import { useNavigate } from "react-router-dom";

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-100 flex items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-3xl border border-zinc-800 bg-[#111113]/95 p-8 text-center shadow-2xl shadow-black/20">
        <h1 className="text-3xl font-heading font-bold text-zinc-100">Unauthorized</h1>
        <p className="mt-3 text-zinc-400">
          You do not have permission to view that page with the current role. Sign in as an Admin or return to Tables.
        </p>

        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="rounded-2xl border border-zinc-700 bg-green-600/10 px-5 py-3 text-sm font-semibold text-green-300 transition hover:bg-green-600/20"
          >
            Go back to Tables
          </button>
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="rounded-2xl border border-zinc-700 bg-zinc-800 px-5 py-3 text-sm font-semibold text-zinc-100 transition hover:border-green-500"
          >
            Sign in as Admin
          </button>
        </div>
      </div>
    </div>
  );
}
